// extracted by mini-css-extract-plugin
module.exports = {"crossIcon":"ClearIcon_crossIcon__V0xBF","crossIcon__1":"ClearIcon_crossIcon__1__J1GPc","crossIcon__2":"ClearIcon_crossIcon__2__jV_hK"};